var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publish"},[_c('div',{staticClass:"publish_button pointer",on:{"click":function($event){return _vm.$store.commit('showDialog')}}},[_c('img',{attrs:{"src":require("@/assets/publish-icon.png")}}),_vm._v(" "),_c('span',[_vm._v("发表")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-03cf83c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/publish.vue
// module id = null
// module chunks = 